export const environment = {
  production: false,
  apiBaseUrl: 'https://driversafety-api-qa.azurewebsites.net/api',
  /** Google reCAPTCHA v2 site key — empty disables captcha (production only) */
  recaptchaSiteKey: '',
  onlineCourseClientUrl:
    'https://nscsandbox.thoughtindustries.com/kane-county-bar-association',
};
